import OrderDeliveryMethod from 'app/features/orders/componentsv1/view/deliveryMethod/OrderDeliveryMethod'
import {selectViewOrderDeliveryMethod} from 'app/features/orders/redux/order/orderSlice'
import {useSelector} from 'react-redux'
import {RootState} from 'setup'



export const DeliveryMethodWrapper = () => {
  const viewDM = useSelector<RootState, string | any>(selectViewOrderDeliveryMethod)

  return <OrderDeliveryMethod orderDeliveryMethod={viewDM} />
}

export default DeliveryMethodWrapper
